import { render, staticRenderFns } from "./TriggerDetail.vue?vue&type=template&id=a2942f66&scoped=true"
import script from "./TriggerDetail.vue?vue&type=script&lang=js"
export * from "./TriggerDetail.vue?vue&type=script&lang=js"
import style0 from "./TriggerDetail.vue?vue&type=style&index=0&id=a2942f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2942f66",
  null
  
)

export default component.exports